export default __webpack_public_path__ + "static/filecleanedfrombluedust-28af31f856981e31acabd0f9fb22f81a.png";